module.exports = __webpack_public_path__ + "img/homebg.545aa503.jpg";